// @flow
import { handleActions } from 'redux-actions';
import { List as ImmutableList, Record } from 'immutable';
import type { RecordFactory } from 'immutable';
import { v4 as uuidv4 } from 'uuid';

import { getLogger } from 'utils/logger';

import * as actions from './postponedActionsActions';
import { mkPostponedAction } from './postponedActionsTypes';

const log = getLogger('data/postponedActions/postponedActionsReducer.js');
export const POSTPONED_ACTIONS_REDUCER_KEY = 'postponedActionsStore';

type PostponedActionsStoreProps = {
  postponedActions: Object,
};
export const mkRetryActionsStore: RecordFactory<PostponedActionsStoreProps> =
  Record({
    postponedActions: new ImmutableList(),
  });

export const reducer = handleActions({
  [actions.addPostponedAction]: (state, { payload }) => {
    log.log('addPostponedAction...');
    const { action } = payload;
    if (payload.maxAttempts && (action.meta === undefined || action.meta.attemptsLeft === undefined)) {
      action.meta = action.meta || {};
      action.meta.attemptsLeft = payload.maxAttempts;
    }
    return state.merge({
      postponedActions: state.postponedActions.push(mkPostponedAction({
        action,
        error: payload.error,
        onFailure: payload.onFailure,
        maxAttempts: payload.maxAttempts,
        key: uuidv4(),
      })),
    });
  },
  [actions.dispatchPostponedActions]: (state, { payload: postponedActions }) => {
    log.log('dispatchPostponedActions...');
    return state.merge({
      postponedActions: state.postponedActions.filterNot((postponedAction) => postponedActions.includes(postponedAction)),
    });
  },
  [actions.dismissPostponedActions]: (state, { payload: postponedActions }) => {
    log.log('dismissPostponedActions...');
    return state.merge({
      postponedActions: state.postponedActions.filterNot((postponedAction) => postponedActions.includes(postponedAction)),
    });
  },
}, mkRetryActionsStore());

export default reducer;
